import React from 'react';
import { Link } from 'react-router-dom';
import { Dog, Shield, TreePine, Star } from 'lucide-react';

const Home = () => {
  return (
    <div className="space-y-16 pb-16">
      
      {/* Hero Section */}
      <section className="relative bg-white/50 py-20 lg:py-32 overflow-hidden">
        <div className="container mx-auto px-6 relative z-10 text-center">
            <h1 className="font-display text-5xl md:text-7xl text-emerald-900 mb-6 drop-shadow-sm">
                Run Free. <span className="text-emerald-600">Sniff Hard.</span>
            </h1>
            <p className="text-xl md:text-2xl text-gray-700 mb-10 max-w-2xl mx-auto leading-relaxed">
                A private, fully fenced sanctuary where dogs can be dogs. No strangers, no stress—just nature and fun.
            </p>
            <div className="flex flex-col sm:flex-row justify-center gap-4">
                <Link to="/app" className="bg-emerald-600 hover:bg-emerald-700 text-white text-lg px-8 py-4 rounded-full font-bold shadow-lg transition-transform transform hover:scale-105">
                    Book Your Spot
                </Link>
                <Link to="/the-spot" className="bg-white hover:bg-gray-50 text-emerald-800 text-lg px-8 py-4 rounded-full font-bold shadow-md transition">
                    Explore the Park
                </Link>
            </div>
        </div>
        {/* Decorative blobs */}
        <div className="absolute top-0 left-0 w-64 h-64 bg-lime-300 rounded-full mix-blend-multiply filter blur-3xl opacity-30 animate-pulse"></div>
        <div className="absolute bottom-0 right-0 w-64 h-64 bg-blue-300 rounded-full mix-blend-multiply filter blur-3xl opacity-30 animate-pulse"></div>
      </section>

      {/* Value Props */}
      <section className="container mx-auto px-6">
        <div className="grid md:grid-cols-3 gap-8">
            <div className="bg-white p-8 rounded-2xl shadow-sm border border-emerald-50 text-center hover:-translate-y-1 transition duration-300">
                <div className="bg-lime-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4 text-emerald-600">
                    <Shield size={32} />
                </div>
                <h3 className="font-display text-2xl text-gray-800 mb-3">Safe & Secure</h3>
                <p className="text-gray-600">6-foot solid fencing with code-locked gates. Perfect for escape artists and peace of mind.</p>
            </div>
            <div className="bg-white p-8 rounded-2xl shadow-sm border border-emerald-50 text-center hover:-translate-y-1 transition duration-300">
                <div className="bg-blue-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4 text-blue-600">
                    <Dog size={32} />
                </div>
                <h3 className="font-display text-2xl text-gray-800 mb-3">Reactive Friendly</h3>
                <p className="text-gray-600">You book the whole park. No surprise dogs, no strangers. Just you and your best friend.</p>
            </div>
            <div className="bg-white p-8 rounded-2xl shadow-sm border border-emerald-50 text-center hover:-translate-y-1 transition duration-300">
                <div className="bg-green-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4 text-green-600">
                    <TreePine size={32} />
                </div>
                <h3 className="font-display text-2xl text-gray-800 mb-3">Nature Driven</h3>
                <p className="text-gray-600">Acres of natural terrain, agility obstacles, and sensory gardens to enrich your dog's mind.</p>
            </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="bg-emerald-900 text-white py-20 rounded-3xl mx-4 lg:mx-8">
        <div className="container mx-auto px-6 text-center">
            <h2 className="font-display text-3xl md:text-4xl mb-12">What the Pack Says</h2>
            <div className="grid md:grid-cols-2 gap-12 max-w-4xl mx-auto">
                <div className="bg-emerald-800 p-8 rounded-xl">
                    <div className="flex justify-center mb-4 text-yellow-400"><Star fill="currentColor" /><Star fill="currentColor" /><Star fill="currentColor" /><Star fill="currentColor" /><Star fill="currentColor" /></div>
                    <p className="italic text-lg mb-6">"Finally a place where my reactive Shepherd can run full speed without me scanning the horizon for other dogs. It's a game changer."</p>
                    <p className="font-bold">- Sarah & 'Rex'</p>
                </div>
                <div className="bg-emerald-800 p-8 rounded-xl">
                    <div className="flex justify-center mb-4 text-yellow-400"><Star fill="currentColor" /><Star fill="currentColor" /><Star fill="currentColor" /><Star fill="currentColor" /><Star fill="currentColor" /></div>
                    <p className="italic text-lg mb-6">"The agility equipment is top notch! We come here every Sunday for 'Sniffari' time. The booking app is super easy too."</p>
                    <p className="font-bold">- Mike & 'Luna'</p>
                </div>
            </div>
        </div>
      </section>

    </div>
  );
};

export default Home;